module.exports = __webpack_public_path__ + "img/selectedFinance.a8881fdc.png";